import styled from "styled-components";

export const ContentArea = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    align-items: center;
    background: ${props => props.theme.colors.white};
    margin-top: 13px;
    > div {
        width: 100%;
    }
`;

export const ContentAreaWrapper = styled(ContentArea)`
   margin-top:0; 
`

export const FiltersRow = styled.div`
  height: auto;
  background: ${props => props.theme.colors.white};
  display: flex;
  align-items: center;
  
  h3 {
    color: ${props => props.theme.colors.darkCharcoal};
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }
`;

export const DetailHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 50px;
`;

export const DetailHeaderLeft = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;


export const BackButton = styled.button`
    border: 0;
    padding: 2px;
    width: 24px;
    height: 24px;
    background: none;
    cursor: pointer;
`;

export const EmptyStateContainer = styled.div`
    display: flex;
    width: 100%;
    padding: 5px;

    & > div  {
        padding: 0;
    }

    & > div > div {
        width: 100%;
        stroke-dasharray: 8,16;
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 400px;
`;